export default "__VITE_ASSET__RzvLtMtQ__"